import { buildSeed } from "@/data/seed";

// Bump when the seed shape changes so stale browser data is replaced.
const STORAGE_KEY = "medilearn_hrms_db_v1";

let cache = null;

function read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function db() {
  if (!cache) {
    cache = read();
    if (!cache) { cache = buildSeed(); persist(); }
  }
  return cache;
}

export function persist() {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(cache)); } catch { /* storage full or blocked — keep in memory */ }
}

export function resetDb() {
  cache = buildSeed();
  persist();
}
